"use client";

import { Amplify } from "aws-amplify";

const userPoolId = process.env.NEXT_PUBLIC_COGNITO_TRAVELERS_USER_POOL;
const userPoolClientId = process.env.NEXT_PUBLIC_COGNITO_TRAVELERS_CLIENT_ID;

if (userPoolId && userPoolClientId) {
	Amplify.configure({
		Auth: {
			Cognito: {
				userPoolId,
				userPoolClientId,
				loginWith: {
					email: true,
				},
				mfa: {
					status: "on",
					smsEnabled: true,
					totpEnabled: true,
				},
			},
		},
	});
} else {
	console.error("Missing required Cognito environment variables");
}

export default function AmplifyProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	return <>{children}</>;
}
